export const addComma = (num) => {
	if (num === undefined) return;
	const parts = isNaN(num) ? num : num.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return parts.join(".");
}

export const getServiceType = (type) => {
	switch (type) {
		case '파트너':
			return '/img/units/carousel-tag-partner.png';
		case '스토어':
			return '/img/units/carousel-tag-store.png';
		case '택배배송':
			return '/img/units/carousel-tag-delivery.png';
		case '편픽':
			return '/img/units/carousel-tag-cu.png';
		case '신라면세점':
			return '/img/units/carousel-tag-silla.png';
		default:
			return '';
	}
}

export const getCustomProperty = (clientId) => {
	const apiUrls = JSON.parse(process.env.REACT_APP_API_URLS);
	const apiKey = JSON.parse(process.env.REACT_APP_API_KEYS);


	return {
		clientId: clientId,
		apiUrls: apiUrls[clientId],
		apiKey: apiKey[clientId],
	}
}

export const getKeywordsList = (topKeywords) => {
	let keywordsArr = [];
	let productsObj = {};
	
	topKeywords.map((data) => {
		keywordsArr.push(data.keyword);
		productsObj[data.keyword] = data.top_items
	})
	return {keywordsArr, productsObj}
}

export const replaceAmpersand = (obj) => {
    // 객체의 각 키에 대해 순회
    for (let key in obj) {
        if (typeof obj[key] === 'string') {
            // 값이 문자열인 경우 &를 @@으로 치환
            obj[key] = obj[key].replace('@@', '&');
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            // 값이 객체나 배열인 경우 재귀적으로 함수 호출
            replaceAmpersand(obj[key]);
        }
    }
}

export const redirectToPage = (url, isNewTab = false) => {
    if (isNewTab) {
        window.open(url, "_blank");
		return;
    } 
	// React Native WebView 환경인지 확인
	const isReactNativeWebView = typeof window.ReactNativeWebView !== "undefined";
	if (isReactNativeWebView) {
		window.ReactNativeWebView.postMessage(
			JSON.stringify({ type: 'redirect', url: url })
		);
	} else {
		const targetWindow = window.parent;
		const redirectState = {
			redirectState: true,
			redirectUrl: url,
		}
		targetWindow.postMessage(redirectState, "*");
	}
    
}

export const setColorCode = (colorCode) => {
	if (!colorCode) return;
	const color0 = `rgba(${colorCode[0].red}, ${colorCode[0].green}, ${colorCode[0].blue}, ${colorCode[0].alpha})`;
	const color1 = `rgba(${colorCode[1].red}, ${colorCode[1].green}, ${colorCode[1].blue}, ${colorCode[1].alpha})`;
	const color2 = `rgba(${colorCode[2].red}, ${colorCode[2].green}, ${colorCode[2].blue}, ${colorCode[2].alpha})`;

    document.documentElement.style.setProperty('--color-prim-800', color0);
    document.documentElement.style.setProperty('--color-prim-200', color1);
    document.documentElement.style.setProperty('--color-prim-100', color2);
}

export const validateInput = (type, value) => {
	let exp;
	let res;
	switch (type) {
		case 'email':
			exp = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
			res = new RegExp(exp).test(value);
			return res;
		case 'password':
			exp = /^[a-zA-Z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]{8,16}$/;
			res = new RegExp(exp).test(value);
			return res;
		default:
			res = value.length > 0;
			return false;
	}
}

export const groupProductsUsingReduce = (products, sliceIndex) => {
    return products.reduce((accumulator, current, index) => {
        if (index % sliceIndex === 0) {
            accumulator.push([]);
        }
        accumulator[accumulator.length - 1].push(current);
        return accumulator;
    }, []);
}

export const findObjectPosition = (data, targetItemId) => {
    for (let outerIndex = 0; outerIndex < data.length; outerIndex++) {
        const innerArray = data[outerIndex];
        for (let innerIndex = 0; innerIndex < innerArray.length; innerIndex++) {
            if (innerArray[innerIndex].itemId === targetItemId) {
                return [outerIndex, innerIndex];
            }
        }
    }
    return null;
}

export const hasUserMessage = (messages) => {
	return messages.some(message => message.isChatbot === false);
}

export const getVisitState = (currentPage) => {
	if (currentPage === undefined) return;
	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || {};
	return visitHistory?.history[currentPage]?.state || false;
}

// export const updateVisitHistory = (currentPage, displayLocation) => {
// 	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || {};
// 	if (visitHistory.history === undefined) {
// 		const initVisitHistory = {
// 			history: {},
// 			prev: {},
// 		}
// 		initVisitHistory.history[currentPage] = {
// 			state: 'visited',
// 			displayLocation: displayLocation,
// 		};
// 		initVisitHistory.prev.pageLocation = currentPage;
// 		initVisitHistory.prev.displayLocation = displayLocation;
// 		sessionStorage.setItem('visitHistory', JSON.stringify(initVisitHistory));
// 	} else {
// 		if (visitHistory.history[currentPage] === undefined) {
// 			visitHistory.history[currentPage] = {
// 				state: 'visited',
// 				displayLocation: displayLocation,
// 			};
// 		} else if (
// 			visitHistory.history[currentPage]?.state === 'visited' && 
// 			visitHistory.prev.displayLocation === 'PRODUCT_DETAIL' &&
// 			visitHistory.prev.pageLocation !== currentPage
// 		) {
// 			visitHistory.history[currentPage] = {
// 				state: 'revisited',
// 				displayLocation: displayLocation,
// 			};
// 		}
// 		visitHistory.prev.pageLocation = currentPage;
// 		visitHistory.prev.displayLocation = displayLocation;
// 		sessionStorage.setItem('visitHistory', JSON.stringify(visitHistory));
// 	}
// }

export const updateVisitHistory = (currentPage, displayLocation) => {
	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || { history: {}, prev: {} };
	const { history, prev } = visitHistory;

	let chatType = null;

	// 처음 방문
	if (!history[currentPage]) {
		history[currentPage] = {
			state: 'visited',
			displayLocation: displayLocation,
		};
		if (displayLocation === 'PRODUCT_DETAIL' && prev.pageLocation !== currentPage) {
			chatType = 'default';
		}
	}

	// 재방문 판별
	else if (
		history[currentPage].state === 'visited' &&
		prev.pageLocation !== currentPage &&
		prev.displayLocation === 'PRODUCT_DETAIL'
	) {
		history[currentPage] = {
			state: 'revisited',
			displayLocation: displayLocation,
		};
		if (displayLocation === 'PRODUCT_DETAIL') {
			chatType = 'revisit';
		}
	}

	// prev 갱신
	visitHistory.prev = { pageLocation: currentPage, displayLocation };
	sessionStorage.setItem('visitHistory', JSON.stringify({ history, prev: visitHistory.prev }));

	return chatType; // null | 'default' | 'revisit'
};


export const savePrevPage = (pageLocation, displayLocation) => {
	const visitHistory = JSON.parse(sessionStorage.getItem('visitHistory')) || { history: {}, prev: {} };
	visitHistory.prev = { pageLocation, displayLocation };
	sessionStorage.setItem('visitHistory', JSON.stringify(visitHistory));
};


export const logToConsole = (data) => {
	const targetWindow = window.parent;
	const chatLog = {
		textResp: data?.text,
		productResp: data?.product,
		itemIdsReq: data?.itemIds,
		exampleResp: data?.examples,
	}
	targetWindow.postMessage({
		type: 'chatLog',
		chatLog: chatLog,
	}, "*");
}

export const sendInputFocusStatus = (state) => {
	const targetWindow = window.parent;
	const inputFocusState = {
		inputFocusState: state,
	}
	targetWindow.postMessage(inputFocusState, "*");
}

export const sendResetState = () => {
	const targetWindow = window.parent;
	const resetState = {
		resetState: true,
	}
	targetWindow.postMessage(resetState, "*");
}

export const sendCloseRequestState = (state) => {
	const targetWindow = window.parent;
	const closeRequestState = {
		closeRequestState: state,
	}
	targetWindow.postMessage(closeRequestState, "*");
}

export const sendEnableChatMode = (mode = 'full') => {
	const targetWindow = window.parent;
	const enableChatMode = {
		enableChatMode: mode,
	}
	targetWindow.postMessage(enableChatMode, "*");
}

export const sendMessageExistence = (state) => {
	const targetWindow = window.parent;
	const messageExistence = {
		messageExistence: state,
	}
	targetWindow.postMessage(messageExistence, "*");
}

export const sendUserSentMessageState = (state) => {
	const targetWindow = window.parent;
	const userSentMessageState = {
		userSentMessageState: state,
	}
	targetWindow.postMessage(userSentMessageState, "*");
}

export const sendAddProductToCart = (product, isConsole, isMobileDevice, setToastMessage, setIsToastVisible) => {
    const targetWindow = window.parent;
        
    const prepaidShippingFee = product.prepaidShipping === 'C' ? 'C' : 'P';
    if (!product.variantList || product.variantList.length === 0) {
        console.warn('variantList of product is empty');
		setToastMessage('이 상품은 직접 담아주세요');	// 추후 수정 필요
        setIsToastVisible(true);
        return;
    } else if (product.variantList.length > 1) {
        if (product?.productUrl && product?.productUrl.length > 0) {
            redirectToPage(
                product?.productUrl, 
                isConsole,
                isMobileDevice
            );
        }
        setToastMessage('이 상품은 옵션 선택이 필요해요');
        setIsToastVisible(true);
        return;
    }
    const productInfo = {
        product_no: product.itemId,
        variants_code: product.variantList[0],
        quantity: 1,
        prepaid_shipping_fee: prepaidShippingFee,
    }
    const addProductToCart = {
        addProductToCart: productInfo,
    }
    targetWindow.postMessage(addProductToCart, "*");
}

export const sendAddProductWithOptionsToCart = (productInfo, optionSelectedProductList) => {
    const targetWindow = window.parent;
        
    const prepaidShippingFee = productInfo.prepaidShipping === 'C' ? 'C' : 'P';
	const productList = optionSelectedProductList.map(product => {

		const optionsList = product.optionValueList.map((optionValue, index) => {
			return {
				option_code: product?.optionCodeList?.[index] || '',
				value_no: product?.optionValueNoList?.[index] || '',
			}
		});
		// 연동형 옵션의 경우, textOptions 내에 [선택] 옵션이 포함되어 있을 수 있음
		const linkedTypeUnrequiredOptions = product?.textOptions?.filter(textOption => (!textOption.isTextOption && !textOption.isFileOption && !textOption.required && textOption.selectedIndex !== null)) || [];
		if (linkedTypeUnrequiredOptions.length > 0) {
			linkedTypeUnrequiredOptions.forEach(option => {
				optionsList.push({
					option_code: option?.optionCode ?? '',
					value_no: option?.value[option?.selectedIndex]?.valueNo ?? '',
				});
			});
		}

		return {
			variants_code: product.variantId,
			quantity: product.quantity,
			options: optionsList,
			additional_option_values: (product.textOptions || []).filter(textOption => textOption.isTextOption).map(textOption => {
				return {
					key: 'item_option_add',
					title: textOption.optionName,
					type: 'text',
					value: textOption.selectedValue,
				}
			})
		}
	}) 
    const addProductWithOptionsToCart = {
		productNo: productInfo.itemId,
		prepaidShippingFee: prepaidShippingFee,
        productList: productList,
    }
	console.log('[chat] addProductWithOptionsToCart', addProductWithOptionsToCart);
    targetWindow.postMessage(
		{ addProductWithOptionsToCart },
		"*"
	);
}

/**
 * snake_case 문자열을 camelCase로 변환
 * @param {string} str - 변환할 문자열
 * @returns {string} camelCase로 변환된 문자열
 */
const snakeToCamel = (str) => {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

/**
 * 객체의 모든 키를 재귀적으로 snake_case에서 camelCase로 변환
 * @param {any} obj - 변환할 객체, 배열, 또는 원시값
 * @returns {any} 변환된 객체, 배열, 또는 원시값
 */
export const deepSnakeToCamel = (obj) => {
    // null, undefined, 또는 원시 타입인 경우 그대로 반환
    if (obj === null || obj === undefined || typeof obj !== 'object') {
        return obj;
    }

    // 배열인 경우 각 요소에 대해 재귀적으로 변환
    if (Array.isArray(obj)) {
        return obj.map(item => deepSnakeToCamel(item));
    }

    // 객체인 경우 모든 키를 변환
    const convertedObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const camelKey = snakeToCamel(key);
            convertedObj[camelKey] = deepSnakeToCamel(obj[key]);
        }
    }
    return convertedObj;
};

// Open a centered small popup window
export const openCenteredWindow = (url, name = 'popup', width = 600, height = 700) => {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;

    const left = Math.max(0, (viewportWidth - width) / 2 + dualScreenLeft);
    const top = Math.max(0, (viewportHeight - height) / 2 + dualScreenTop);

    const features = `scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left},noopener,noreferrer`;
    const newWindow = window.open(url, name, features);
    if (newWindow && newWindow.focus) newWindow.focus();
};

/**
 * Copy text to the user's clipboard (desktop and mobile).
 * Uses navigator.clipboard when available and falls back to a hidden textarea + execCommand.
 * Should be called in a user-gesture context (e.g., click/submit) for best compatibility.
 */
export const copyToClipboard = async (text) => {
    if (!text) return;
    // Modern API in secure contexts
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        } catch (e) {
            // Fallback below
        }
    }
    // Fallback for older browsers / iOS Safari
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        // Avoid scrolling to bottom on iOS
        textArea.style.position = 'fixed';
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.opacity = '0';
        textArea.setAttribute('readonly', '');
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);
        document.execCommand('copy');
        document.body.removeChild(textArea);
    } catch (e) {
        // As a last resort, try a contentEditable element
        try {
            const span = document.createElement('span');
            span.textContent = text;
            span.style.whiteSpace = 'pre';
            span.contentEditable = 'true';
            span.style.position = 'fixed';
            span.style.top = '0';
            span.style.left = '0';
            span.style.opacity = '0';
            document.body.appendChild(span);
            const range = document.createRange();
            range.selectNodeContents(span);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
            selection.removeAllRanges();
            document.body.removeChild(span);
        } catch (_) {
            // Give up silently
        }
    }
}